import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";

interface TrendingCategory {
  category: string;
  total_score: number;
  startup_count: number;
}

interface Props {
  data: TrendingCategory[];
}

export default function TrendingCategoriesChart({ data }: Props) {
  if (!data || data.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-muted-foreground">
        No trending categories data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis 
          dataKey="category" 
          className="text-xs"
          angle={-45}
          textAnchor="end"
          height={100}
        />
        <YAxis className="text-xs" />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: "hsl(var(--background))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "8px"
          }}
        />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="total_score" 
          stroke="hsl(var(--primary))" 
          strokeWidth={2}
          name="Trend Score"
          dot={{ fill: "hsl(var(--primary))" }}
        />
        <Line 
          type="monotone" 
          dataKey="startup_count" 
          stroke="hsl(var(--accent))" 
          strokeWidth={2}
          name="Startup Count"
          dot={{ fill: "hsl(var(--accent))" }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
